export const BaseUrl = "https://idonate.ajanmane.com";
// export const BaseUrl = "https://be1c-49-34-103-90.in.ngrok.io";
// export const StripeKey =
//   "pk_live_51MUhcMDa29JlcCbLP1am8G40mJgncsvPMd7gZxKFtvHd15ZUG0E00StItEqqXM9oVWZzq2TCN7zDCpFhbDQCUXi500PVDR0xi1";
export const StripeKey =
  "pk_test_51MUhcMDa29JlcCbLq4QzPSL2TVFvVoaVfmri6pTF6UALCzzSmTQEeobb8CaudUpPiY1YyLDafTBTTjwgh4pcoaIs00AhXqbLxE";
